export const enum eBrokerPortalRouteNames {
  BrokerPortal = 'BrokerPortal::BrokerPortal',
}
